<template>
  <custom-dialog width="520px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :rules="rules" ref="form" label-position="top">
        <el-form-item :label="$t('dms_add_open_pwd_dialog.mi_ma')" prop="rfid">
          <el-input :maxlength="6" placeholder="" v-model="form.rfid"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_add_open_pwd_dialog.shi_yong_ren')" prop="cardOwner">
          <el-input placeholder="" v-model="form.cardOwner"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_add_open_pwd_dialog.lian_xi_dian_hua')" prop="cardOwnerPhone">
          <el-input placeholder="" v-model="form.cardOwnerPhone"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        cardOwner: '',
        cardOwnerPhone: '',
        rfid: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        rfid: [{ required: true, min: 6, max: 6, message: this.$t('Common.com_rules_length_equal', [6]), trigger: 'blur' }],
      };
    },
  },
  mounted: function () {
  },
  methods: {
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        const numReg = /^\d{1,}$/;
        if (!numReg.test(this.form.rfid)) {
          this.$message.error(this.$t('dms_add_open_pwd_dialog.mmbxwsz'));
          return;
        }
        const list = this.model.row || [];
        const has = list.findIndex((t) => t.rfid === this.form.rfid);
        if (has !== -1) {
          this.$message.error(this.$t('dms_add_open_pwd_dialog.mmyczqcxsr'));
          return;
        }
        this.$emit('success', [this.form]);
      });
    },
  },
};
</script>

<style lang="scss"></style>
